import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: 0.25rem;
`

export const Label = styled.label`
  appearance: none;
  display: block;

  margin-bottom: 0.8rem;
`

const fieldDefaults = css`
  appearance: none;
  border: none;
  outline: none;

  background: 1px solid white;
  border-radius: 50px;

  display: block;
  width: 100%;

  padding: 0.75rem 1rem;
`

export const StyledInput = styled.input`
  ${fieldDefaults};
`

export const StyledSelect = styled.select`
  ${fieldDefaults};
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAMFJREFUKBVjYBgFQyQEGLeLSDUwMjLWk+Le/wwMazxePw1n8nzzrIGB4X8nsZpBGjleP41kZGD4B8QQsENEup+BkaEAxsdGwzQ6MjD8AcnDNYM4O4Sl5jIwMSaB2Jjg/w721898YRpB8kzIitzfPktl+Pd/HrIYhA3WGIisESSOYjNIAOg0pp3CUrNhLvjP8P8Ix+tnrkCNP0DyyABDM0gSZMAOUemVQJYEB8NvT8fXr78gayLI3s/AwLJfVJQHn0IAjPo5+OGwP6gAAAAASUVORK5CYII=');
  background-size: 15px;
  background-repeat: no-repeat;
  background-position: 97% calc(50% - 2px);
`

export const StyledTextArea = styled.textarea`
  ${fieldDefaults};
  border-radius: 30px;
  resize: none;
`

export const StyledError = styled.div`
  height: calc(0.8rem * 1.3);
  margin-top: 0.25rem;

  color: #fd4949;
  font-size: 0.8rem;
  line-height: 1.3;

  ${props =>
    props.isValid &&
    css`
      opacity: 0;
    `}
`
